var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/$.uid.js
// module id = 158
// module chunks = 1 2